import SidebarGroup from "../sidebarGroup"
import useLayout from "hooks/useLayout"
import SidebarRow from "../SidebarRow"
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg'
import { ReactComponent as AddIcon } from 'assets/icons/add.svg'
import { ReactComponent as HistoryIcon } from 'assets/icons/restore.svg'
import RightSidebar from "./RightSidebar"
import { useTranslation } from "react-i18next"
import useAccess from "@/hooks/useAccess"
import { AccessRole } from "@/types"
import useCategories from "@/hooks/useCategories"
import { useState } from "react"
import { ReactComponent as RestoreIcon } from 'assets/icons/restore_from_trash.svg'

interface RightSidebarCategoryProps {
    className?: string;
    children?: React.ReactNode;
    storageId?: string;
    categoryId?: string;
}

const RightSidebarCategory: React.FC<RightSidebarCategoryProps> = ({ className, children, storageId, categoryId }) => {

    const { t } = useTranslation()
    
    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    const {
        category,
        restoreCategoryAsync,
        isRestoring
    } = useCategories({ storageId, categoryId })

    const {
        openDialog,
        addToast
    } = useLayout()

    const [isRestoringState, setIsRestoringState] = useState(false)

    const handleRestoreClick = async () => {
        if (!storageId || !categoryId) return
        setIsRestoringState(true)
        try {
            await restoreCategoryAsync({
                storageId,
                categoryId
            })
            addToast({
                text: t('categoryRestored'),
                colorScheme: 'green'
            })
        } catch (error) {
            addToast({
                text: t('failedToRestore'),
                colorScheme: 'red'
            })
        } finally {
            setIsRestoringState(false)
        }
    }

    // Return the sidebar component.
    return (
        <RightSidebar storageId={storageId}>
            <SidebarGroup title={t('menuCategoryActions')} allwaysOpen={true}>
            <SidebarRow onClick={() => openDialog('category_history')} text={t('buttonViewHistory')} icon={<HistoryIcon />} style={`border`} />
            {limitToRoles([AccessRole.OWNER, AccessRole.EDITOR]) && <>
                {!category?.isDeleted && (
                    <>
                        <SidebarRow 
                            to={`/storage/categories/create`}
                            state={{
                                categoryId: categoryId,
                            }} text={t('buttonNewChildCategory')} icon={<AddIcon />} style={`border`} />
                        <SidebarRow to={`/storage/categories/${categoryId}/edit`} text={t('buttonEditCategory')} icon={<EditIcon />} style={`border`} />
                        <SidebarRow to={`/storage/categories/${categoryId}/edit_custom_inputs`} text={t('buttonEditCustomInputs')} icon={<EditIcon />} style={`border`} />
                        <SidebarRow onClick={() => openDialog(`delete_category`, {storageId, categoryId})} text={t('buttonDelete')} icon={<DeleteIcon />} style={`border`} />
                    </>
                )}
                {category?.isDeleted && (
                    <SidebarRow 
                        onClick={handleRestoreClick} 
                        text={isRestoring || isRestoringState ? t('restoringItem') : t('restoreCategory')} 
                        icon={<RestoreIcon />}
                        style={`border`} 
                    />
                )}
            </>}
            </SidebarGroup>
        </RightSidebar>
    )
}

export default RightSidebarCategory

